/**
 * Official W7 wordmark — design system:
 * lowercase "w" (white) + "7" (brand orange). Same mark as the console rail.
 * @see specs/design-system/w7/tokens.yaml brand.logo.wordmark
 */

export function W7Mark({
  className,
  size = 36,
  suffix,
}: {
  className?: string
  size?: number
  /** Optional product label, e.g. "ops console" */
  suffix?: string
}) {
  return (
    <span
      className={['w7-logo', 'w7-auth-wordmark', className].filter(Boolean).join(' ')}
      style={{ fontSize: size }}
      aria-hidden={suffix ? undefined : true}
    >
      <span>w</span>
      <b>7</b>
      {suffix ? <em>{suffix}</em> : null}
    </span>
  )
}
